import { isEmpty, isNaN, map, get, replace, some } from "lodash";
import moment from "moment";

export function phoneFormat(string) {
	if (!isEmpty(string)) {
		const cleanString = string.replace(/[^\d]/g, "");
		if (cleanString.length === 10) {
			return cleanString.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
		}
		if (cleanString.length === 11) {
			return cleanString.replace(/(\d{1})(\d{3})(\d{3})(\d{4})/, "$1 ($2) $3-$4");
		}
		return cleanString;
	}
	return "";
}

export function padWithZero(number) {
	if (isNaN(number)) return "";
	const string = number.toString();
	if (number < 10) {
		return `0${string}`;
	}
	return string;
}
export function dropdownFormat(data, label, value) {
	const formatData = map(data, (item, index) => {
		return { key: index + 1, text: get(item, label, ""), value: get(item, value, "") };
	});
	return formatData;
}

export function getDayDiffLabel(seconds) {
	if (isNaN(seconds)) return "";
	const minutes = Math.floor(seconds / 60);
	const hours = Math.floor(minutes / 60);
	const days = Math.floor(hours / 24);

	return `${days} días`;
}

export function getClockLabel(seconds) {
	if (isNaN(seconds)) return "";
	const minutes = Math.floor(seconds / 60);
	const hours = Math.floor(minutes / 60);
	const days = Math.floor(hours / 24);

	const hrs = hours - days * 24;
	const mins = minutes - hrs * 60 - days * 24 * 60;

	if (hrs < 1) return `${mins}m`;
	if (days < 1) return `${hrs}h ${mins}m`;
	return `${days}d ${hrs}h ${mins}m`;
}

export function getCallDurationLabel(seconds) {
	if (isNaN(seconds)) return "";
	const minutes = Math.floor(seconds / 60);
	const hours = Math.floor(minutes / 60);
	const days = Math.floor(hours / 24);

	const hrs = hours - days * 24;
	const mins = minutes - hours * 60;
	const secs = Math.floor(seconds % 60);

	if (hours < 1 && minutes < 1) return `${secs}s`;
	if (hours < 1) return `${mins}m ${secs}s`;
	if (days < 1) return `${hrs}h ${mins}m ${secs}s`;
	return `${days}d ${hrs}h ${mins}m ${secs}s`;
}

export function getTimerLabel(seconds) {
	if (isNaN(seconds)) return "";
	const minutes = Math.floor(seconds / 60);
	const hours = Math.floor(minutes / 60);

	const mins = minutes - hours * 60;
	const secs = seconds - hours * 60 * 60 - mins * 60;

	if (hours < 1) return `${padWithZero(mins)}:${padWithZero(secs)}`;
	return `${padWithZero(hours)}:${padWithZero(mins)}:${padWithZero(secs)}`;
}

export function getAudioLabel(timeInSeconds) {
	if (isNaN(timeInSeconds)) return "";
	const mins = Math.floor(timeInSeconds / 60);
	const secs = Math.floor(timeInSeconds % 60);

	return `${padWithZero(mins)}:${padWithZero(secs)}`;
}

export function dateFormat(date) {
	const ogDate = date;
	if (date && !Array.isArray(date)) {
		const dateVal = new Date(date);
		const HM =
			date.getHours() > 12
				? `${parseHours(dateVal.getHours() - 12)}:${parseMinutes(dateVal.getMinutes())} PM`
				: `${parseHours(dateVal.getHours())}:${parseMinutes(dateVal.getMinutes())} AM`;
		if (isNaN(date.getDate()) || isNaN(parseInt(dateVal.getMonth(), 10) || isNaN(dateVal.getFullYear()))) return ogDate;
		return `${dateVal.getDate()}/${parseInt(dateVal.getMonth(), 10) + 1}/${dateVal.getFullYear()}  ${HM}`;
	}
	return "";
}

function parseHours(hours) {
	if (hours < 10) {
		return `0${hours}`;
	}
	return hours;
}

function parseMinutes(minutes) {
	if (minutes < 10) {
		return `0${minutes}`;
	}
	return minutes;
}

export function formatDate(time, format) {
	return moment(time).format(format);
}

export const fileToBase64 = async (file) => {
	return new Promise((resolve, reject) => {
		if (!file) {
			reject(new Error("Sin archivo"));
			return;
		}
		const reader = new FileReader();
		reader.onloadend = () => {
			return resolve(reader.result);
		};
		reader.onerror = reject;
		reader.readAsDataURL(file);
	});
};

export const showPdf = (url) => {
	const path = `${import.meta.env.VITE_API_URL}${url}`;
	return path;
};

export const formatPhone = (rawPhone = "") => {
	const phone = replace(rawPhone, /[^\d]/g, "");

	if (phone.length === 10) {
		return `+1 (${phone.slice(0, 3)}) ${phone.slice(3, 6)}-${phone.slice(6)}`;
	}
	if (phone.length === 11 && phone.startsWith("1")) {
		return `+1 (${phone.slice(1, 4)}) ${phone.slice(4, 7)}-${phone.slice(7)}`;
	}

	return rawPhone;
};

export const getBlacklistParts = (text, blackListKeyWords) => {
	if (isEmpty(blackListKeyWords)) return [{ text, isBlocked: false }];

	const escapedKeywords = map(blackListKeyWords, (k) => {
		return replace(k, /[.*+?^${}()|[\]\\]/g, "\\$&");
	});

	const regex = new RegExp(`\\b(${escapedKeywords.join("|")})\\b`, "gi");
	const parts = text.split(regex);

	return map(parts, (part) => {
		const isBlocked = some(blackListKeyWords, (k) => {
			return new RegExp(`^${k}$`, "i").test(part);
		});
		return { text: part, isBlocked };
	});
};
